import React, { Component } from 'react';
import ApplyToAllLocations from '../multiLocation/ApplyToAllLocations';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import siteSetting from "../../config/env";
import {userActions} from "../../_actions";
import toast from '../shared/Toast';
import { normaliseImage } from '../shared/normaliseImage';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import {hairdresserService, salonService} from "../../_services";
import SettingsPageLayout from './SettingsPageLayout';
import { lockBodyScroll, unlockBodyScroll } from '../../_utils/useScrollLock';
import './SettingsModern.css';

const searchOptions = {
    //componentRestrictions: { country: ['GB'] },
    //types: ['city']
}

// Representative container aspect ratios (width / height) for the surfaces the
// headline image renders in. Driven by the real CSS: website hero ~50vh full
// width, marketplace card 288x218, mobile hero ~60vh full width.
const CROP_SURFACES = { web: 3, card: 4 / 3, mobile: 3 / 4 };

// Given the uploaded image's aspect ratio R (width / height), work out which
// centred fraction of it each surface shows under object-fit: cover, then the
// website crop (the widest, our "max") and the safe area visible on every
// surface (the intersection, our "min"). Fractions are 0..1 of the image.
function computeCropBounds(R) {
    if (!R || !isFinite(R) || R <= 0) return null;
    const visibleFraction = (C) => (R >= C ? { w: C / R, h: 1 } : { w: 1, h: R / C });
    const web = visibleFraction(CROP_SURFACES.web);
    const card = visibleFraction(CROP_SURFACES.card);
    const mobile = visibleFraction(CROP_SURFACES.mobile);
    const safe = {
        w: Math.min(web.w, card.w, mobile.w),
        h: Math.min(web.h, card.h, mobile.h),
    };
    // Note: the card crop never binds the safe area (its ratio sits between web
    // and mobile), so web-band ∩ mobile-band already equals the true safe zone.
    return { web, mobile, safe };
}

// Turn a centred {w,h} fraction into absolute box CSS over the image.
function centredBoxStyle(box) {
    return {
        left: `${((1 - box.w) / 2) * 100}%`,
        top: `${((1 - box.h) / 2) * 100}%`,
        width: `${box.w * 100}%`,
        height: `${box.h * 100}%`,
    };
}
class SalonSettings extends Component {

    constructor(props){
        super(props);

        this.state = {
            isProfileSettingTab: false,
            salonImagePrev:require('../../assets/images/salonpic.png'),
            salonImage:'',
            salonName:'',
            allow:false,
            salonUrl:'',
            deviceToken:'asfasfasfas',
            isShow:localStorage.getItem('isShow'),
            deleteSalonModal: false,
            isEdit:false,
            clientShare:0,
            isLoading:false,
            diaryShare:0,
            businessType:'hair_salon',
            onlineBookingContactPhone:'',
            onlineBookingContactEmail:'',
            showCallButton: true,
            showEmailButton: true,
            // Bio/description
            bio: '',
            // Email branding
            useCustomEmailImage: false,
            emailHeaderImage: '',
            emailHeaderImageUrl: '',
            emailPrimaryColor: '',
            // Gallery images
            galleryImages: [],
            galleryUploading: false,
            // Natural aspect ratio of the headline image, measured on load, so
            // the crop-bound overlays line up with the actual photo.
            headlineRatio: null,
            // Whether the per-device "View crop preview" modal is open.
            showCropPreview: false,
            // Opening hours state
            openingHours: [
                { dayName: 'Monday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Tuesday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Wednesday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Thursday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Friday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Saturday', sTime: '09:00', eTime: '17:00', isClose: false },
                { dayName: 'Sunday', sTime: '09:00', eTime: '17:00', isClose: true }
            ],
            openingHoursLoading: false,
            openingHoursSaving: false
        }
        this.onChanged=this.onChanged.bind(this);
        this.updateSalon=this.updateSalon.bind(this);
        // this.checkReadOnly=this.checkReadOnly.bind(this);
    }

    componentDidMount() {
        var self = this;
        if (localStorage.getItem('accessToken')) {
            // First get the salonId from user profile, then fetch salon settings from v2 API
            let params = {
                defaultRedirectTo: localStorage.getItem('defaultRedirectTo')
            }
            params.latitude = siteSetting.default_latitude;
            params.longitude = siteSetting.default_longitude;
            
            self.props.dispatch(userActions.profile(params))
                .then(function (response) {
                    // Safely check for hairdresser and salon data
                    const userInfo = self.props.user?.userInfo;
                    const hairdresser = userInfo?.hairdresser;
                    const salon = hairdresser?.salon;
                    
                    if (response.data.data && salon && salon._id) {
                        const salonId = salon._id;
                        
                        // Fetch salon settings from v2 API
                        self.fetchSalonSettings(salonId);
                    } else {
                        // User is not a hairdresser or doesn't have a salon
                        console.log('User does not have hairdresser/salon access:', { userInfo, hairdresser, salon });
                        self.props.history.push('/');
                    }
                })
                .catch((err) => {
                    console.error('Error fetching profile:', err);
                    self.props.history.push('/');
                });
        } else {
            self.props.history.push('/');
        }
    }

    fetchSalonSettings = (salonId) => {
        const self = this;
        
        salonService.getSalonSettings(salonId)
            .then(function(response) {
                // Handle v2 API response format
                const responseData = response.data.responseData || response.data;
                
                if (responseData.statusCode === 1 && responseData.data) {
                    const salonData = responseData.data;
                    
                    let clientShare = 0;
                    if (self.checkReadOnly()) { // salon owner
                        clientShare = salonData.clientShare;
                    } else { // self emp
                        clientShare = self.props.user?.userInfo?.hairdresser?.clientShare || 0;
                    }
                    
                    // If no gallery images but there's a salon image, add it as the first gallery image
                    let galleryImages = salonData.galleryImages || [];
                    if (galleryImages.length === 0 && salonData.imageUrl) {
                        galleryImages = [{
                            url: salonData.imageUrl,
                            caption: '',
                            order: 0
                        }];
                    }
                    
                    self.setState({
                        salonUrl: siteSetting.api.weburl + 'salon/' + salonData.salonId,
                        salonName: salonData.salonName,
                        formattedAddress: salonData.formattedAddress,
                        administrativeAreaLevel1: salonData.administrativeAreaLevel1,
                        administrativeAreaLevel2: salonData.administrativeAreaLevel2,
                        countryLongName: salonData.countryLongName,
                        countryShortName: salonData.countryShortName,
                        latitude: salonData.latitude,
                        longitude: salonData.longitude,
                        salonId: salonData.salonId,
                        isShow: salonData.isShow,
                        postalCode: salonData.postalCode,
                        clientShare: clientShare,
                        salonImagePrev: salonData.imageUrl || require('../../assets/images/salonpic.png'),
                        diaryShare: salonData.diaryShare,
                        businessType: salonData.businessType || 'hair_salon',
                        // Empty array is truthy in JS so a plain `||` would
                        // happily replace the 7-day default state with [] and
                        // leave the user with no hours rows to edit. Length
                        // check ensures we only override with a populated set.
                        openingHours: (Array.isArray(salonData.opening_hours) && salonData.opening_hours.length > 0)
                            ? salonData.opening_hours
                            : self.state.openingHours,
                        onlineBookingContactPhone: salonData.onlineBookingContactPhone || '',
                        onlineBookingContactEmail: salonData.onlineBookingContactEmail || '',
                        showCallButton: salonData.showCallButton !== undefined ? salonData.showCallButton : true,
                        showEmailButton: salonData.showEmailButton !== undefined ? salonData.showEmailButton : true,
                        bio: salonData.bio || '',
                        galleryImages: galleryImages,
                        emailHeaderImage: salonData.emailHeaderImage || '',
                        useCustomEmailImage: !!(salonData.emailHeaderImage && salonData.emailHeaderImage !== ''),
                        emailHeaderImageUrl: salonData.emailHeaderImageUrl || '',
                        emailPrimaryColor: salonData.emailPrimaryColor || ''
                    });
                } else {
                    // Fallback to old data from user profile if v2 API fails
                    console.error('Failed to fetch salon settings from v2 API, using fallback');
                    self.loadSalonDataFromProfile();
                }
            })
            .catch(function(err) {
                console.error('Error fetching salon settings:', err);
                // Fallback to old data from user profile
                self.loadSalonDataFromProfile();
            });
    }

    loadSalonDataFromProfile = () => {
        const self = this;
        const hairdresser = self.props.user?.userInfo?.hairdresser;
        const salon = hairdresser?.salon;
        if (salon) {
            let clientShare = 0;
            if (self.checkReadOnly()) { // salon owner
                clientShare = salon.clientShare;
            } else { // self emp
                clientShare = hairdresser?.clientShare || 0;
            }
            self.setState({
                salonUrl: siteSetting.api.weburl + 'salon/' + salon._id,
                salonName: salon.salonName,
                formattedAddress: salon.formattedAddress,
                administrativeAreaLevel1: salon.administrativeAreaLevel1,
                administrativeAreaLevel2: salon.administrativeAreaLevel2,
                countryLongName: salon.countryLongName,
                countryShortName: salon.countryShortName,
                latitude: salon.loc?.[1],
                longitude: salon.loc?.[0],
                salonId: salon._id,
                isShow: salon.isShow,
                postalCode: salon.postalCode,
                clientShare: clientShare,
                salonImagePrev: salon.imageUrl ? salon.imageUrl : require('../../assets/images/salonpic.png'),
                diaryShare: salon.diaryShare,
                businessType: salon.businessType || 'hair_salon',
                onlineBookingContactPhone: salon.onlineBookingContactPhone || '',
                onlineBookingContactEmail: salon.onlineBookingContactEmail || '',
                showCallButton: salon.showCallButton !== undefined ? salon.showCallButton : true,
                showEmailButton: salon.showEmailButton !== undefined ? salon.showEmailButton : true,
            }, () => {
                // Fetch opening hours after salon data is loaded
                self.fetchOpeningHours();
            });
        }
    }

    fetchOpeningHours = () => {
        const self = this;
        if (!this.state.salonId) return;
        
        this.setState({ openingHoursLoading: true });
        
        salonService.getOpeningHours(this.state.salonId)
            .then(function(response) {
                // Handle both response formats: response.data.data and response.data.responseData.data
                let openingHoursData = null;
                if (response.data && response.data.responseData && response.data.responseData.data && response.data.responseData.data.opening_hours) {
                    openingHoursData = response.data.responseData.data.opening_hours;
                } else if (response.data && response.data.data && response.data.data.opening_hours) {
                    openingHoursData = response.data.data.opening_hours;
                }
                
                // Same length-check as above — empty array would otherwise
                // wipe the 7-day default state.
                if (Array.isArray(openingHoursData) && openingHoursData.length > 0) {
                    self.setState({
                        openingHours: openingHoursData,
                        openingHoursLoading: false
                    });
                } else {
                    self.setState({ openingHoursLoading: false });
                }
            })
            .catch(function(err) {
                console.error('Error fetching opening hours:', err);
                self.setState({ openingHoursLoading: false });
            });
    }

    handleOpeningHoursChange = (dayIndex, field, value) => {
        // This is called on blur - save to server
        this.saveOpeningHours();
    }

    handleDayToggle = (dayIndex) => {
        const self = this;
        const openingHours = [...this.state.openingHours];
        openingHours[dayIndex] = {
            ...openingHours[dayIndex],
            isClose: !openingHours[dayIndex].isClose
        };
        this.setState({ openingHours }, () => {
            // Save immediately when toggling open/closed
            self.saveOpeningHours();
        });
    }

    saveOpeningHours = () => {
        const self = this;
        
        // Don't show saving state for auto-save to avoid UI flicker
        salonService.updateOpeningHours(this.state.salonId, this.state.openingHours)
            .then(function(response) {
                if (response.data && response.data.statusCode === 1) {
                    // Silent success - no toast for auto-save
                } else {
                    toast.error(response.data.message || 'Failed to update opening hours');
                }
            })
            .catch(function(err) {
                console.error('Error saving opening hours:', err);
                toast.error('Failed to update opening hours');
            });
    }

    // Measure the headline image's natural ratio so the crop overlays match it.
    handleHeadlineImageLoad = (e) => {
        const { naturalWidth, naturalHeight } = e.target;
        if (naturalWidth && naturalHeight) {
            const ratio = naturalWidth / naturalHeight;
            if (ratio !== this.state.headlineRatio) {
                this.setState({ headlineRatio: ratio });
            }
        }
    }

    // Gallery image handlers
    handleGalleryImageUpload = async (e) => {
        const self = this;
        const file = e.target.files[0];
        // Store reference to the input element before async operations
        const inputElement = e.target;
        if (!file) return;

        // Check file type
        const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'];
        if (!validTypes.includes(file.type) && file.type !== 'image/heic') {
            toast.error('Please select a valid image file (JPEG, PNG, GIF, or WebP)');
            return;
        }

        this.setState({ galleryUploading: true });

        try {
            // Resize + re-encode before upload. Gallery photos were going to
            // S3 at full camera resolution (9MP phone shots displayed at a few
            // hundred px), which is what makes the salon profile slow to load.
            // normaliseImage also covers the HEIC conversion this used to do
            // by hand, and falls back to the raw file if anything fails.
            const uploadFile = await normaliseImage(file);

            const response = await salonService.uploadGalleryImage(this.state.salonId, uploadFile);
            const responseData = response.data.responseData || response.data;
            
            if (responseData.statusCode === 1 && responseData.data) {
                const newImage = responseData.data;
                self.setState(prevState => ({
                    galleryImages: [...prevState.galleryImages, newImage],
                    galleryUploading: false
                }));
                toast.success('Image uploaded successfully');
            } else {
                toast.error(responseData.message || 'Failed to upload image');
                self.setState({ galleryUploading: false });
            }
        } catch (err) {
            console.error('Error uploading gallery image:', err);
            toast.error('Failed to upload image');
            self.setState({ galleryUploading: false });
        }

        // Reset the file input using the stored reference
        if (inputElement) {
            inputElement.value = '';
        }
    }

    handleDeleteGalleryImage = async (imageUrl) => {
        const self = this;

        if (!window.confirm('Are you sure you want to delete this image?')) {
            return;
        }

        // The marketplace headline is the salon's main image, which the backend
        // syncs from the first gallery image on reorder. Deleting the first
        // image doesn't touch the main image, so the client keeps showing the
        // deleted photo. If we just removed the headline, re-persist the order
        // of what's left so the main image re-points at the new first image.
        const wasHeadline = self.state.galleryImages[0] && self.state.galleryImages[0].url === imageUrl;

        try {
            const response = await salonService.deleteGalleryImage(this.state.salonId, imageUrl);
            const responseData = response.data.responseData || response.data;

            if (responseData.statusCode === 1) {
                const remaining = self.state.galleryImages
                    .filter(img => img.url !== imageUrl)
                    .map((img, i) => ({ ...img, order: i }));
                self.setState({ galleryImages: remaining });
                toast.success('Image deleted successfully');

                if (wasHeadline && remaining.length > 0) {
                    try {
                        await salonService.reorderGalleryImages(
                            self.state.salonId,
                            remaining.map(img => ({ url: img.url, order: img.order }))
                        );
                    } catch (err) {
                        console.error('Error re-syncing headline image after delete:', err);
                    }
                }
            } else {
                toast.error(responseData.message || 'Failed to delete image');
            }
        } catch (err) {
            console.error('Error deleting gallery image:', err);
            toast.error('Failed to delete image');
        }
    }

    handleMoveGalleryImage = async (index, direction) => {
        const self = this;
        const images = [...this.state.galleryImages];
        let newIndex;
        
        if (direction === 'front') {
            // Move image to the front (make it the headline image)
            newIndex = 0;
            const [movedImage] = images.splice(index, 1);
            images.unshift(movedImage);
        } else {
            newIndex = direction === 'up' ? index - 1 : index + 1;
            
            if (newIndex < 0 || newIndex >= images.length) return;

            // Swap the images
            [images[index], images[newIndex]] = [images[newIndex], images[index]];
        }
        
        // Update order values
        images.forEach((img, i) => {
            img.order = i;
        });

        this.setState({ galleryImages: images });

        try {
            const reorderData = images.map((img, i) => ({
                url: img.url,
                order: i
            }));
            
            await salonService.reorderGalleryImages(this.state.salonId, reorderData);
        } catch (err) {
            console.error('Error reordering gallery images:', err);
            toast.error('Failed to save image order');
        }
    }

    handleChange = address => {
        this.setState({ formattedAddress:address });
    };

    handleSelect = address => {
        geocodeByAddress(address)
            .then(results => {
                // parseGooglePlace(results)
                // console.log("results===>>",results);
                let countryShortName='';
                let countryLongName='';
                let postalCode='';
                let administrativeAreaLevel1='';
                let administrativeAreaLevel2='';

                const address_components = results[0].address_components;
                for (let i = 0; i < address_components.length; i++) {
                    const component = address_components[i];
                    if (component['types'][0]) {
                        if (component['types'][0] === 'administrative_area_level_2') {

                            administrativeAreaLevel2 = component['long_name'];

                        }
                        if (component['types'][0] === 'administrative_area_level_1') {

                            administrativeAreaLevel1 = component['short_name'];

                        }
                        if (component['types'][0] === 'postal_code') {

                            postalCode = component['long_name'];

                        }
                        if (component['types'][0] === 'country') {

                            countryShortName = component['short_name'];
                            countryLongName= component['long_name'];

                        }
                    }
                }
                this.setState({
                    formattedAddress:results[0].formatted_address,
                    countryShortName:countryShortName,
                    countryLongName:countryLongName,
                    postalCode:postalCode,
                    administrativeAreaLevel1:administrativeAreaLevel1,
                    administrativeAreaLevel2:administrativeAreaLevel2,
                });

                return getLatLng(results[0])
            })
            .then(latLng => {
                console.log('Success', latLng);
                this.setState({
                    latitude: latLng.lat?latLng.lat:siteSetting.default_latitude,
                    longitude: latLng.lng?latLng.lng:siteSetting.default_longitude,
                })
            })
            .catch(error => console.error('Error', error));
    };

 

    onChanged=async (e)=> {
        let self = this;
        //console.log("e.target.name",e.target)
        this.setState({ [e.target.name]: e.target.value, copied: false });

        if (e.target.name === 'email') {
            if (!this.validateEmail(e.target.value)) {
                this.setState({
                    emailError: 'Please enter a valid email address'
                })
            } else {
                this.setState({
                    emailError: ''
                })
            }
        }

        if (e.target.name === 'first_name') {
            if (e.target.value === '' || e.target.value === null) {
                this.setState({
                    fNameError: ''
                })
            } else {
                this.setState({
                    fNameError: '',
                })
            }
        }

        if (e.target.name === 'salonImage') {
            const file = e.target.files[0];
            if (!file) return;

            // One path for every format now. normaliseImage resizes and
            // re-encodes to JPEG (and converts HEIC), so the salon logo no
            // longer goes to S3 at full camera resolution; it falls back to
            // the raw file if anything fails.
            const uploadFile = await normaliseImage(file);

            // Preview must be a STRING: the render reads it as an <img src>
            // and calls .includes() on it. The old code briefly assigned the
            // File object itself, which threw there until the async reader
            // replaced it a tick later.
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ salonImagePrev: reader.result });
            };
            reader.readAsDataURL(uploadFile);

            this.setState({ salonImage: uploadFile }, function () {
                self.updateSalon();
            });
        }
    }

    toggleChange = () => {
        this.setState({
            isShow: !this.state.isShow,
        });
    }
    clip=(event)=>{
        event.target.select();
        navigator.clipboard.writeText(this.state.salonUrl)
    }

    updateSalon(){
        this.setState({
            error:''
        })
        let self = this;

            if (this.state.salonName === "" || this.state.salonName === undefined) {
                this.setState({
                    salonNameError: 'Please enter salon name'
                })
            } else if (this.state.formattedAddress === "" || this.state.formattedAddress === undefined) {
                this.setState({
                    formattedAddressError: 'Please enter salon address'
                })
            } else {
                let data = new FormData();
                data.append('salonId', this.state.salonId);
                data.append('salonName', this.state.salonName);
                data.append('formattedAddress', this.state.formattedAddress);
                data.append('latitude', parseFloat(this.state.latitude));
                data.append('longitude', parseFloat(this.state.longitude));
                data.append('countryShortName', this.state.countryShortName);
                data.append('countryLongName', this.state.countryLongName);
                data.append('postalCode', this.state.postalCode);
                data.append('administrativeAreaLevel1', this.state.administrativeAreaLevel1);
                data.append('administrativeAreaLevel2', this.state.administrativeAreaLevel2);
                data.append('deviceToken', this.state.deviceToken);
                data.append('image', this.state.salonImage);
                data.append('isShow', this.state.isShow);
                data.append('clientShare', this.state.clientShare);
                data.append('diaryShare', this.state.diaryShare);
                data.append('businessType', this.state.businessType);
                data.append('onlineBookingContactPhone', this.state.onlineBookingContactPhone);
                data.append('onlineBookingContactEmail', this.state.onlineBookingContactEmail);
                data.append('showCallButton', this.state.showCallButton ? 1 : 0);
                data.append('showEmailButton', this.state.showEmailButton ? 1 : 0);
                data.append('bio', this.state.bio);
                data.append('emailHeaderImage', this.state.useCustomEmailImage ? this.state.emailHeaderImage : '');
                data.append('emailPrimaryColor', this.state.emailPrimaryColor || '');
                this.setState({
                    isLoading:true
                })
                
                salonService.updateSalon(data)
                    .then(function (response) {
                        // Handle both v1 and v2 API response formats
                        const responseData = response.data.responseData || response.data;
                        
                        // Check for v2 API success (statusCode: 1) or v1 API success (no errorCode)
                        if (responseData.statusCode === 1 || (!response.data.errorCode && !responseData.errorCode)) {
                            localStorage.setItem('isShow', self.state.isShow);
                            toast.success(responseData.message || 'Your salon has been updated successfully');
                            self.setState({
                                successMessage: responseData.message || 'Your salon has been updated successfully!',
                                isEdit: false
                            });
                            
                            // Update image preview if a new image was uploaded
                            if (responseData.data && responseData.data.imageUrl) {
                                self.setState({
                                    salonImagePrev: responseData.data.imageUrl
                                });
                            }
                        } else {
                            // Handle error
                            const errorMessage = responseData.message || responseData.messages || 'Failed to update salon';
                            if (response.data.errorCode === 51 || responseData.errorCode === 51) {
                                self.setState({
                                    salonNameError: errorMessage
                                });
                            } else {
                                self.setState({
                                    error: errorMessage
                                });
                            }
                            toast.error(errorMessage);
                        }

                        self.setState({
                            isLoading: false
                        });
                    })
                    .catch((err) => {
                        console.log("errr", err);
                        toast.error('Failed to update salon settings');
                        self.setState({
                            isLoading: false,
                            error: 'Failed to update salon settings'
                        });
                    })
            }

    }

    clientShareService=()=>{
        let self=this;
        this.setState({
            error:''
        })
            let clientShare=this.state.clientShare;
            let data={
                clientShare
            }
            this.setState({
                isLoading: true
            })

            hairdresserService.clientShare(data)
                .then(function (response) {
                    if (response.data.errorCode) {
                        if (response.data.errorCode == 51) {
                            self.setState({
                                salonNameError: response.data.messages
                            })
                            toast.error(response.data.messages);
                        }
                        else {
                            toast.error(response.data.messages);
                            self.setState({
                                error: response.data.messages
                            })
                        }
                    } else {
                        localStorage.setItem('isShow', self.state.isShow);
                        //self.props.history.push('/setting')
                        toast.success('Your salon has been updated successfully');
                        self.setState({
                            successMessage: 'Your salon has been updated successfully!',
                            isEdit: false
                        })
                    }

                    self.setState({
                        isLoading: false
                    })
                })
                .catch((err) => {
                    console.log("errr", err);
                    //dispatch(failure(err));

                })


    }

    gotoHome=()=>{
        this.props.history.push('/diary/'+localStorage.getItem('salonId'))
    }

    handleClose = () => this.setState({
        deleteSalonModal: false,
    })

    checkReadOnly=()=>{
        if(this.props.user&&this.props.user.userInfo&&this.props.user.userInfo.hairdresser.isSalonOwner===1){
            return true;
        }else{
            return false;
        }
    }

    checkClientShareAccess=()=>{
        if(this.props.user&&this.props.user.userInfo&&(this.props.user.userInfo.hairdresser.isSalonOwner===1||(this.props.user.userInfo.hairdresser.isSalonOwner===0&&this.props.user.userInfo.hairdresser.employmentTypeId===2))){
            return true;
        }else{
            return false;
        }
    }

    noClick=()=>{

    }
    componentWillUnmount() {
        document.body.classList.remove('setting-temps-pages');
        // Don't leave the page scroll-locked if we unmount while the crop
        // preview modal is open. Only release OUR lock — the old unconditional
        // clear could unlock a different overlay's lock.
        if (this.state.showCropPreview) {
            unlockBodyScroll();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Lock background scroll while the crop preview modal is open so the
        // page behind the popup can't scroll (shared ref-counted lock).
        if (prevState.showCropPreview !== this.state.showCropPreview) {
            if (this.state.showCropPreview) lockBodyScroll();
            else unlockBodyScroll();
        }
    }


    editStatusChange=(status)=>{
        if (status) {
            // Entering edit mode: store original values for cancel-revert
            this.setState({
                isEdit: true,
                _originalValues: {
                    salonName: this.state.salonName,
                    formattedAddress: this.state.formattedAddress,
                    businessType: this.state.businessType,
                    bio: this.state.bio,
                    onlineBookingContactPhone: this.state.onlineBookingContactPhone,
                    onlineBookingContactEmail: this.state.onlineBookingContactEmail,
                    showCallButton: this.state.showCallButton,
                    showEmailButton: this.state.showEmailButton,
                    administrativeAreaLevel1: this.state.administrativeAreaLevel1,
                    administrativeAreaLevel2: this.state.administrativeAreaLevel2,
                    countryLongName: this.state.countryLongName,
                    countryShortName: this.state.countryShortName,
                    latitude: this.state.latitude,
                    longitude: this.state.longitude,
                    postalCode: this.state.postalCode,
                }
            });
        } else {
            // Cancelling: revert to original values
            const orig = this.state._originalValues || {};
            this.setState({
                isEdit: false,
                _originalValues: null,
                ...orig
            });
        }
    }

    checkboxChange=(e)=>{
        let self=this;
        if (typeof e === "object" && e.target.id === "clientShare") {
            this.setState({ clientShare: this.state.clientShare===1?0:1 },function (){
                // self.updateSalon();
                self.clientShareService();
            })
        }
        if (typeof e === "object" && e.target.id === "diaryShare") {
            this.setState({ diaryShare: this.state.diaryShare===1?0:1 },function (){
                self.updateSalon();
            })
        }
    }

    getBusinessTypeLabel = (type) => {
        const types = {
            hair_salon: 'Hair Salon',
            barber: 'Barber',
            beauty_salon: 'Beauty Salon',
            nail_salon: 'Nail Salon',
            spa: 'Spa',
            other: 'Other'
        };
        return types[type] || type;
    }

    render() {
        const { deleteSalonModal, isEdit, galleryImages, galleryUploading, openingHours, openingHoursLoading, showCropPreview } = this.state;
        const isOwner = this.checkReadOnly();
        const cropBounds = computeCropBounds(this.state.headlineRatio);
        const headlineUrl = galleryImages[0] && galleryImages[0].url;
        // Safe-zone pixel size for the recommended 16:9 canvas, derived from the
        // same crop maths as the preview so the number always matches the boxes.
        const RECOMMENDED_SIZE = { w: 2560, h: 1440 };
        const recommendedBounds = computeCropBounds(RECOMMENDED_SIZE.w / RECOMMENDED_SIZE.h);
        const safeW = recommendedBounds ? Math.round(RECOMMENDED_SIZE.w * recommendedBounds.safe.w) : 0;
        const safeH = recommendedBounds ? Math.round(RECOMMENDED_SIZE.h * recommendedBounds.safe.h) : 0;

        return (
            <SettingsPageLayout activeTab="salon-details" {...this.props}>

                {/* ── Business Images ── */}
                <div className="settings-card">
                    <div className="settings-card-header">
                        <h2>Business Images</h2>
                        <p>Add photos of your business. The first image is your headline image on the marketplace.</p>
                    </div>

                    {galleryImages.length > 0 ? (
                        <>
                            {/* Headline Image — the whole photo with the website
                                (widest) crop and the always-visible safe area marked
                                on it, so owners see the crop range at a glance. The
                                exact per-device crops are one click away. */}
                            <div className="salon-headline-preview">
                                <div className="salon-headline-preview__top">
                                    <span className="salon-gallery-badge salon-gallery-badge--inline">Headline Image</span>
                                    {isOwner && (
                                        <button
                                            className="salon-gallery-action-btn salon-gallery-action-btn--danger"
                                            onClick={() => this.handleDeleteGalleryImage(galleryImages[0].url)}
                                            title="Delete"
                                        >
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                                        </button>
                                    )}
                                </div>

                                <div className="salon-headline-card">
                                    <div className="salon-headline-card__frame" style={{ aspectRatio: String(this.state.headlineRatio || (16 / 9)) }}>
                                        <img src={headlineUrl} alt="Headline image" onLoad={this.handleHeadlineImageLoad} />
                                        {cropBounds && (
                                            <>
                                                <span className="crop-bound crop-bound--web" style={centredBoxStyle(cropBounds.web)} />
                                                <span className="crop-bound crop-bound--mobile" style={centredBoxStyle(cropBounds.mobile)} />
                                                <span className="crop-bound crop-bound--safe" style={centredBoxStyle(cropBounds.safe)} />
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="salon-headline-legend">
                                    <span className="salon-headline-legend__item">
                                        <i className="legend-swatch legend-swatch--web" />Website crop (cuts top &amp; bottom)
                                    </span>
                                    <span className="salon-headline-legend__item">
                                        <i className="legend-swatch legend-swatch--mobile" />Mobile crop (cuts sides)
                                    </span>
                                    <span className="salon-headline-legend__item">
                                        <i className="legend-swatch legend-swatch--safe" />Always visible (safe area)
                                    </span>
                                    <button
                                        type="button"
                                        className="salon-headline-preview-btn"
                                        onClick={() => this.setState({ showCropPreview: true })}
                                    >
                                        View crop preview
                                    </button>
                                </div>

                                <div className="salon-headline-info">
                                    <p>This is how your headline image is cropped across the marketplace and booking page. Keep your logo, faces and text inside the safe area so they stay visible everywhere. On the marketplace card, the corners and bottom strip also sit under your salon name and buttons.</p>
                                    <p className="salon-headline-info__spec">Recommended: landscape JPG, 2560 × 1440px (16:9). Minimum 1920 × 1080px. Keep your logo, faces and text within the centre {safeW} × {safeH}px so they stay inside the safe area on every device.</p>
                                </div>
                            </div>

                            {/* Gallery Grid */}
                            <div className="salon-gallery-grid">
                                {galleryImages.slice(1).map((image, index) => (
                                    <div key={index + 1} className="salon-gallery-thumb">
                                        <img src={image.url} alt={image.caption || `Image ${index + 2}`} />
                                        {isOwner && (
                                            <div className="salon-gallery-actions">
                                                <button
                                                    className="salon-gallery-action-btn salon-gallery-action-btn--star"
                                                    onClick={() => this.handleMoveGalleryImage(index + 1, 'front')}
                                                    title="Make headline image"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                                                </button>
                                                <button
                                                    className="salon-gallery-action-btn salon-gallery-action-btn--danger"
                                                    onClick={() => this.handleDeleteGalleryImage(image.url)}
                                                    title="Delete"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {isOwner && (
                                    <div
                                        className={'salon-gallery-add' + (galleryUploading ? ' salon-gallery-uploading' : '')}
                                        onClick={() => !galleryUploading && this.galleryImageInput.click()}
                                    >
                                        {galleryUploading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="sr-only">Uploading...</span>
                                            </div>
                                        ) : (
                                            <>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                                <span>Add Image</span>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>

                            {showCropPreview && headlineUrl && (
                                <div className="salon-crop-modal" onClick={() => this.setState({ showCropPreview: false })}>
                                    <div className="salon-crop-modal__content" onClick={(e) => e.stopPropagation()}>
                                        <div className="salon-crop-modal__header">
                                            <h3>Crop preview</h3>
                                            <button
                                                type="button"
                                                className="salon-crop-modal__close"
                                                onClick={() => this.setState({ showCropPreview: false })}
                                                title="Close"
                                            >
                                                <svg width="16" height="16" viewBox="0 0 14 14" fill="none"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
                                            </button>
                                        </div>
                                        <p className="salon-crop-modal__sub">Exactly how your headline image appears on each surface.</p>
                                        <div className="salon-headline-preview__frames">
                                            <figure className="salon-crop salon-crop--web">
                                                <div className="salon-crop__frame"><img src={headlineUrl} alt="Website preview" /></div>
                                                <figcaption>Website</figcaption>
                                            </figure>
                                            <figure className="salon-crop salon-crop--card">
                                                <div className="salon-crop__frame"><img src={headlineUrl} alt="Marketplace card preview" /></div>
                                                <figcaption>Marketplace card</figcaption>
                                            </figure>
                                            <figure className="salon-crop salon-crop--mobile">
                                                <div className="salon-crop__frame"><img src={headlineUrl} alt="Mobile preview" /></div>
                                                <figcaption>Mobile</figcaption>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <div
                            className={'salon-gallery-add' + (galleryUploading ? ' salon-gallery-uploading' : '')}
                            style={{ aspectRatio: 'auto', padding: '60px 20px' }}
                            onClick={() => !galleryUploading && this.galleryImageInput.click()}
                        >
                            {galleryUploading ? (
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="sr-only">Uploading...</span>
                                </div>
                            ) : (
                                <>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                                    <span style={{ fontSize: '14px', fontWeight: 500 }}>Upload your first photo</span>
                                </>
                            )}
                        </div>
                    )}

                    {galleryImages.length > 1 && (
                        <p style={{ fontSize: '12px', color: '#999', marginTop: '14px' }}>
                            Click the star on any image to make it your headline image.
                        </p>
                    )}

                    <input
                        ref={(ref) => this.galleryImageInput = ref}
                        type="file"
                        accept="image/*"
                        onChange={this.handleGalleryImageUpload}
                        style={{ display: 'none' }}
                    />
                    <input ref={(ref) => this.salonImage = ref} type="file" name="salonImage" onChange={this.onChanged} style={{ display: 'none' }} />
                </div>

                {/* ── Business Details ── */}
                <div className="settings-card">
                    <div className="settings-card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                            <h2>Business Details</h2>
                            <p>This information is displayed on your online booking page.</p>
                        </div>
                        <ApplyToAllLocations area="branding" label="branding" />
                        {isOwner && !isEdit && (
                            <button className="settings-btn-link" onClick={() => this.editStatusChange(true)}>Edit</button>
                        )}
                    </div>

                    {!isEdit ? (
                        /* ── View Mode ── */
                        <div className="salon-detail-grid">
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">Business Name</span>
                                <span className={'salon-detail-value' + (!this.state.salonName ? ' salon-detail-value--empty' : '')}>{this.state.salonName || 'Not set'}</span>
                            </div>
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">Location</span>
                                <span className={'salon-detail-value' + (!this.state.formattedAddress ? ' salon-detail-value--empty' : '')}>{this.state.formattedAddress || 'Not set'}</span>
                            </div>
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">Business Type</span>
                                <span className="salon-detail-value">{this.getBusinessTypeLabel(this.state.businessType)}</span>
                            </div>
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">About</span>
                                <span className={'salon-detail-value' + (!this.state.bio ? ' salon-detail-value--empty' : '')}>{this.state.bio || 'Not set'}</span>
                            </div>
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">Phone</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                                    <span className={'salon-detail-value' + (!this.state.onlineBookingContactPhone ? ' salon-detail-value--empty' : '')} style={{ flex: 1 }}>{this.state.onlineBookingContactPhone || 'Not set'}</span>
                                    {this.state.onlineBookingContactPhone && (
                                        <span style={{ fontSize: '12px', color: this.state.showCallButton ? '#007EA0' : '#999' }}>
                                            {this.state.showCallButton ? 'Call button visible' : 'Call button hidden'}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="salon-detail-row">
                                <span className="salon-detail-label">Email</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                                    <span className={'salon-detail-value' + (!this.state.onlineBookingContactEmail ? ' salon-detail-value--empty' : '')} style={{ flex: 1 }}>{this.state.onlineBookingContactEmail || 'Not set'}</span>
                                    {this.state.onlineBookingContactEmail && (
                                        <span style={{ fontSize: '12px', color: this.state.showEmailButton ? '#007EA0' : '#999' }}>
                                            {this.state.showEmailButton ? 'Email button visible' : 'Email button hidden'}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        /* ── Edit Mode ── */
                        <div>
                            <div className="settings-form-group">
                                <label className="settings-label">Business Name</label>
                                <input type="text" className="settings-input" value={this.state.salonName} name="salonName" onChange={this.onChanged} />
                                {this.state.salonNameError && <span className="cm_error_msg">{this.state.salonNameError}</span>}
                            </div>

                            <div className="settings-form-group">
                                <label className="settings-label">Business Location</label>
                                <div className="address_input_wrap w-100">
                                    <PlacesAutocomplete
                                        searchOptions={searchOptions}
                                        value={this.state.formattedAddress}
                                        onChange={this.handleChange}
                                        onSelect={this.handleSelect}
                                    >
                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                            <div>
                                                <input
                                                    {...getInputProps({
                                                        placeholder: 'Search Places ...',
                                                        className: 'settings-input',
                                                    })}
                                                />
                                                {suggestions.length > 0 && (
                                                    <div className="autocomplete_location">
                                                        {loading && <div>Loading...</div>}
                                                        {suggestions.map(suggestion => {
                                                            const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                                                            const style = suggestion.active
                                                                ? { backgroundColor: '#ffffff', cursor: 'pointer' }
                                                                : { backgroundColor: '#e4e4e4', cursor: 'pointer' };
                                                            return (
                                                                <div {...getSuggestionItemProps(suggestion, { className, style })}>
                                                                    <span>{suggestion.description}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </PlacesAutocomplete>
                                </div>
                                {this.state.formattedAddressError && <span className="cm_error_msg">{this.state.formattedAddressError}</span>}
                            </div>

                            <div className="settings-form-row">
                                <div className="settings-form-group">
                                    <label className="settings-label">Business Type</label>
                                    <select className="settings-input" value={this.state.businessType} name="businessType" onChange={this.onChanged}>
                                        <option value="hair_salon">Hair Salon</option>
                                        <option value="barber">Barber</option>
                                        <option value="beauty_salon">Beauty Salon</option>
                                        <option value="nail_salon">Nail Salon</option>
                                        <option value="spa">Spa</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div className="settings-form-group">
                                    <label className="settings-label">Phone Number</label>
                                    <input type="tel" className="settings-input" value={this.state.onlineBookingContactPhone} name="onlineBookingContactPhone" onChange={this.onChanged} placeholder="e.g. +44 20 1234 5678" />
                                    {this.state.onlineBookingContactPhone && (
                                        <div className="settings-toggle-row" style={{ marginTop: '8px', padding: '0' }}>
                                            <span style={{ fontSize: '13px', color: '#555' }}>Show Call button</span>
                                            <button type="button"
                                                className={'ds-toggle' + (this.state.showCallButton ? ' ds-toggle--on' : '')}
                                                onClick={() => this.setState({ showCallButton: !this.state.showCallButton })}
                                            >
                                                <span className="ds-toggle-knob" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="settings-form-group">
                                <label className="settings-label">Email Address</label>
                                <input type="email" className="settings-input" value={this.state.onlineBookingContactEmail} name="onlineBookingContactEmail" onChange={this.onChanged} placeholder="e.g. bookings@yoursalon.com" />
                                {this.state.onlineBookingContactEmail && (
                                    <div className="settings-toggle-row" style={{ marginTop: '8px', padding: '0' }}>
                                        <span style={{ fontSize: '13px', color: '#555' }}>Show Email button</span>
                                        <button type="button"
                                            className={'ds-toggle' + (this.state.showEmailButton ? ' ds-toggle--on' : '')}
                                            onClick={() => this.setState({ showEmailButton: !this.state.showEmailButton })}
                                        >
                                            <span className="ds-toggle-knob" />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="settings-form-group">
                                <label className="settings-label">About Your Business</label>
                                <textarea
                                    className="settings-input"
                                    value={this.state.bio}
                                    name="bio"
                                    onChange={this.onChanged}
                                    placeholder="Tell clients about your business, your specialties, and what makes you unique..."
                                    rows="4"
                                    style={{ resize: 'vertical', minHeight: '100px' }}
                                />
                            </div>

                            <p style={{ fontSize: '13px', color: '#888', marginBottom: '20px', lineHeight: '1.5' }}>
                                Use the toggles above to control whether <strong style={{ color: '#333' }}>Call</strong> and <strong style={{ color: '#333' }}>Email</strong> buttons appear on your online booking page.
                            </p>

                            <hr className="settings-divider" />

                            <div className="settings-btn-group" style={{ justifyContent: 'flex-end' }}>
                                <button className="settings-btn settings-btn-secondary" onClick={() => this.editStatusChange(false)}>Cancel</button>
                                <button className="settings-btn settings-btn-primary" onClick={this.updateSalon.bind(this)} disabled={this.state.isLoading}>
                                    {this.state.isLoading ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* ── Opening Hours ── */}
                {isOwner && (
                    <div className="settings-card">
                        <div className="settings-card-header">
                            <h2>Opening Hours</h2>
                            <p>Set your business hours. Changes save automatically.</p>
                        </div>

                        {openingHoursLoading ? (
                            <div className="settings-loading">
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="salon-hours-list">
                                {openingHours.map((day, index) => (
                                    <div key={day.dayName} className="salon-hours-row">
                                        <div className="salon-hours-day">
                                            <button
                                                type="button"
                                                className={'ds-toggle' + (!day.isClose ? ' ds-toggle--on' : '')}
                                                onClick={() => this.handleDayToggle(index)}
                                            >
                                                <span className="ds-toggle-knob" />
                                            </button>
                                            <span className="salon-hours-day-name">{day.dayName}</span>
                                        </div>
                                        {day.isClose ? (
                                            <span className="salon-hours-closed">Closed</span>
                                        ) : (
                                            <div className="salon-hours-times">
                                                <input
                                                    type="time"
                                                    className="settings-input"
                                                    value={day.sTime}
                                                    onBlur={(e) => this.handleOpeningHoursChange(index, 'sTime', e.target.value)}
                                                    onChange={(e) => {
                                                        const hrs = [...this.state.openingHours];
                                                        hrs[index] = { ...hrs[index], sTime: e.target.value };
                                                        this.setState({ openingHours: hrs });
                                                    }}
                                                />
                                                <span className="salon-hours-separator">to</span>
                                                <input
                                                    type="time"
                                                    className="settings-input"
                                                    value={day.eTime}
                                                    onBlur={(e) => this.handleOpeningHoursChange(index, 'eTime', e.target.value)}
                                                    onChange={(e) => {
                                                        const hrs = [...this.state.openingHours];
                                                        hrs[index] = { ...hrs[index], eTime: e.target.value };
                                                        this.setState({ openingHours: hrs });
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {/* ── Email Branding ── */}
                {isOwner && (
                    <div className="settings-card">
                        <div className="settings-card-header">
                            <h2>Email Branding</h2>
                            <p>Customise the image and colour that appear in emails sent to your clients.</p>
                        </div>

                        {/* Preview */}
                        <div style={{
                            background: this.state.emailPrimaryColor || '#29282D',
                            borderRadius: '12px',
                            padding: '24px 20px 20px',
                            textAlign: 'center',
                            marginBottom: '16px'
                        }}>
                            {(this.state.useCustomEmailImage && this.state.emailHeaderImageUrl) || (!this.state.useCustomEmailImage && this.state.salonImagePrev && !this.state.salonImagePrev.includes('salonpic.png')) ? (
                                <img
                                    src={this.state.useCustomEmailImage ? this.state.emailHeaderImageUrl : this.state.salonImagePrev}
                                    alt="Email header"
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid rgba(255,255,255,0.3)',
                                        marginBottom: '12px'
                                    }}
                                />
                            ) : null}
                            <p style={{ color: '#fff', fontSize: '16px', fontWeight: 600, margin: '0 0 4px' }}>
                                {this.state.salonName || 'Your Salon'}
                            </p>
                            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px', margin: 0 }}>
                                Powered by Beu
                            </p>
                        </div>
                        <p style={{ fontSize: '12px', color: '#999', margin: '0 0 16px', textAlign: 'center' }}>
                            Preview of how your email header will look
                        </p>

                        {/* Header Colour */}
                        <div style={{ marginBottom: '24px' }}>
                            <label className="settings-label">Header Colour</label>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '8px' }}>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    {['#29282D', '#007EA0', '#1a1a1a', '#2C3E50', '#8E44AD', '#C0392B', '#27AE60', '#F39C12'].map((color) => (
                                        <div
                                            key={color}
                                            onClick={() => {
                                                this.setState({ emailPrimaryColor: color === '#29282D' ? '' : color }, () => {
                                                    this.updateSalon();
                                                });
                                            }}
                                            style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '50%',
                                                backgroundColor: color,
                                                cursor: 'pointer',
                                                border: (this.state.emailPrimaryColor || '#29282D') === color
                                                    ? '3px solid #007EA0'
                                                    : '2px solid #e0e0e0',
                                                boxShadow: (this.state.emailPrimaryColor || '#29282D') === color
                                                    ? '0 0 0 2px #fff, 0 0 0 4px #007EA0'
                                                    : 'none'
                                            }}
                                        />
                                    ))}
                                </div>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="color"
                                        value={this.state.emailPrimaryColor || '#29282D'}
                                        onChange={(e) => {
                                            this.setState({ emailPrimaryColor: e.target.value });
                                        }}
                                        onBlur={() => {
                                            this.updateSalon();
                                        }}
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            border: 'none',
                                            borderRadius: '50%',
                                            cursor: 'pointer',
                                            padding: 0,
                                            background: 'none'
                                        }}
                                        title="Pick a custom colour"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Email Image */}
                        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                            <div className="settings-toggle-row" style={{ borderBottom: 'none', padding: 0, marginBottom: '16px' }}>
                                <div>
                                    <span className="settings-toggle-label" style={{ marginBottom: '4px' }}>Use custom email image</span>
                                    <p style={{ fontSize: '13px', color: '#888', margin: 0, lineHeight: '1.5' }}>
                                        {this.state.useCustomEmailImage
                                            ? 'Using a separate image for emails'
                                            : 'Using your salon profile image for emails'}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    className={'ds-toggle' + (this.state.useCustomEmailImage ? ' ds-toggle--on' : '')}
                                    onClick={() => {
                                        const newVal = !this.state.useCustomEmailImage;
                                        this.setState({ useCustomEmailImage: newVal }, () => {
                                            if (!newVal) {
                                                this.setState({ emailHeaderImage: '' }, () => {
                                                    this.updateSalon();
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <span className="ds-toggle-knob" />
                                </button>
                            </div>

                            {this.state.useCustomEmailImage && (
                                <div>
                                    {/* Upload new image */}
                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
                                        <button
                                            className="settings-btn-secondary"
                                            style={{ fontSize: '13px', padding: '8px 16px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer' }}
                                            onClick={() => this.emailImageInput && this.emailImageInput.click()}
                                        >
                                            Upload New Image
                                        </button>
                                        {this.state.emailHeaderImageUrl && (
                                            <span style={{ fontSize: '12px', color: '#888' }}>or select from gallery below</span>
                                        )}
                                    </div>
                                    <input
                                        ref={(ref) => this.emailImageInput = ref}
                                        type="file"
                                        accept="image/*"
                                        onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;
                                            // Reuse existing gallery upload to S3, then set the key
                                            try {
                                                this.setState({ galleryUploading: true });
                                                // Same resize/re-encode as the other uploads
                                                const uploadFile = await normaliseImage(file);
                                                const response = await salonService.uploadGalleryImage(this.state.salonId, uploadFile);
                                                const responseData = response.data.responseData || response.data;
                                                if (responseData.statusCode === 1 && responseData.data && responseData.data.image) {
                                                    const uploadedUrl = responseData.data.image.url;
                                                    const uploadedKey = uploadedUrl.split('/').pop();
                                                    this.setState({
                                                        emailHeaderImage: uploadedKey,
                                                        emailHeaderImageUrl: uploadedUrl,
                                                        galleryUploading: false
                                                    }, () => {
                                                        this.updateSalon();
                                                        // Refresh gallery
                                                        this.fetchSalonSettings(this.state.salonId);
                                                    });
                                                } else {
                                                    this.setState({ galleryUploading: false });
                                                    toast.error('Failed to upload image');
                                                }
                                            } catch (err) {
                                                console.error('Email image upload error:', err);
                                                this.setState({ galleryUploading: false });
                                                toast.error('Failed to upload image');
                                            }
                                            e.target.value = '';
                                        }}
                                        style={{ display: 'none' }}
                                    />

                                    {/* Gallery picker */}
                                    {galleryImages.length > 0 && (
                                        <div>
                                            <label className="settings-label" style={{ marginBottom: '8px', display: 'block' }}>Or select from your gallery</label>
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                {galleryImages.map((img, index) => {
                                                    const imgKey = img.url.split('/').pop();
                                                    const isSelected = this.state.emailHeaderImage === imgKey || this.state.emailHeaderImageUrl === img.url;
                                                    return (
                                                        <div
                                                            key={index}
                                                            onClick={() => {
                                                                this.setState({
                                                                    emailHeaderImage: imgKey,
                                                                    emailHeaderImageUrl: img.url
                                                                }, () => {
                                                                    this.updateSalon();
                                                                });
                                                            }}
                                                            style={{
                                                                width: '64px',
                                                                height: '64px',
                                                                borderRadius: '50%',
                                                                overflow: 'hidden',
                                                                border: isSelected ? '3px solid #007EA0' : '2px solid #e0e0e0',
                                                                cursor: 'pointer',
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <img
                                                                src={img.url}
                                                                alt={img.caption || `Image ${index + 1}`}
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Diary Sharing is now a standalone settings tab accessible
                    from the top nav / mobile menu — see useSettingsTabs.js */}

                <Modal show={deleteSalonModal} onHide={this.handleClose} className="bg_white_modal text-center">
                    <i className="fa fa-times cm_hide_mod" onClick={this.handleClose} />
                    <Modal.Body>
                        <div className="p-5">
                            <img src={require('../../assets/images/delete-salon-img.png')} className="img-fluid mb-3" />
                            <h3 style={{ fontSize: '38px', fontWeight: '400' }} className="mb-4">Delete Salon</h3>
                            <p style={{ fontSize: '23px', fontWeight: '300' }}>Are you sure you want to delete the salon? This will cancel all appointments and remove the salon from Beu. Staff will be free to join or create another salon.</p>
                            <div className="stap-action mt-5">
                                <button className="btn btn-outline-dark mr-3">Cancel</button>
                                <button className="btn btn-pink">Delete Salon</button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

            </SettingsPageLayout>
        )
    }

}



function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(SalonSettings);





